type BlogImageFields = {
  image?: string;
  thumbnail?: string;
};

/**
 * Matches legacy Blade + admin uploads:
 * - thumbnail (~500KB max): list cards, featured blocks, home/stage teasers
 * - image (~1MB max): post detail hero, OG/share on detail
 */
export const getBlogCardImage = (blog?: BlogImageFields | null) =>
  blog?.thumbnail || blog?.image || "";

export const getBlogDetailCoverImage = (blog?: BlogImageFields | null) =>
  blog?.image || blog?.thumbnail || "";
